import React, { useContext } from 'react';

import { Context } from '@store/store';

import ArrowLeftIcon from './icons/arrow-left-icon';
import ArrowRightIcon from './icons/arrow-right-icon';

import {
  StyledArrowLeftButton,
  StyledArrowRightButton,
} from './arrow-button.styles';

const ArrowButtons = () => {
  const [state, dispatch] = useContext(Context);

  return (
    <React.Fragment>
        {state.currentPage === 0 ? null : (
          <StyledArrowLeftButton
            onClick={() => {
              dispatch({ type: 'SET_PREV_PAGE' });
            }}
            title={
              state.isSinglePageMode
                ? 'Перейти на предыдущую страницу'
                : 'Перейти на предыдущие страницы'
            }
          >
            <ArrowLeftIcon />
          </StyledArrowLeftButton>
        )}
        {state.isSinglePageMode ? (
          state.currentPage === state.pagesCount - 1 ? null : (
            <StyledArrowRightButton
              onClick={() => {
                dispatch({ type: 'SET_NEXT_PAGE' });
              }}
              title={
                state.isSinglePageMode
                  ? 'Перейти на следующую страницу'
                  : 'Перейти на следующие страницы'
              }
            >
              <ArrowRightIcon />
            </StyledArrowRightButton>
          )
        ) : state.currentPage === state.pagesCount - 1 ? null : (
          <StyledArrowRightButton
            onClick={() => {
              dispatch({ type: 'SET_NEXT_PAGE' });
            }}
            title={
              state.isSinglePageMode
                ? 'Перейти на следующую страницу'
                : 'Перейти на следующие страницы'
            }
          >
            <ArrowRightIcon />
          </StyledArrowRightButton>
        )}
    </React.Fragment>
  );
};

export default ArrowButtons;
